module.exports = __webpack_public_path__ + "img/gp12.ec6bd27f.jpg";